<template>
  <div class="print">

    <!-- 1 Page -->
    <div>
      <div style="padding-top:20px;">
        <h1 class="font-bold flex justify-center items-center" style="height:96px; font-size: 32px; color: #000">사업주 안전·보건활동 결과보고서</h1>
      </div>

      <div class="grid grid-cols-1 gap-3" style="color:#2C2C2C">
        <div>
          <h3 style="margin-bottom: 6px; font-size:20px;">Ⅰ. 건설현장 개요</h3>
          <table class="w-full" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
            <colgroup>
              <col width="160px" />
              <col width="333px" />
              <col width="160px" />
              <col width="333px" />
            </colgroup>
            <tbody>
            <tr>
              <td>①연 번</td>
              <td>{{ form.연번 }}</td>
              <td>현장명</td>
              <td>{{ form.현장명.com_name }}</td>
            </tr>
            <tr>
              <td>방문 일시</td>
              <td>{{ form.방문일시 }}</td>
              <td>②사업장관리번호<br>(사업개시번호)</td>
              <td>{{ form.사업장관리번호 }}</td>
            </tr>
            <tr>
              <td>소재지</td>
              <td>{{ form.소재지 }}</td>
              <td>공사금액<br>(VAT 포함)</td>
              <td>{{ form.공사금액 | comma }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h3 style="margin-bottom: 6px; font-size:20px;">Ⅱ. 사업주 안전·보건 간담회</h3>
          <table class="w-full" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
            <colgroup>
              <col width="60px" />
              <col width="100px" />
              <col width="333px" />
              <col width="493px" />
            </colgroup>
            <tbody>
            <tr>
              <td class="border-l-0" rowspan="2" style="border-bottom: 3px solid #2d2d2d;">참석자</td>
              <td >본사</td>
              <td class="border-r-0 py-0 text-left" colspan="2">
                <div class="grid grid-cols-3">
                  <template v-for="(user, index) in form.안전보건간담회_본사">
                    <p :key="`안전보건간담회_본사_${index}_소속`" class="py-3">(소속) {{user.소속}}</p>
                    <p :key="`안전보건간담회_본사_${index}_직급`" class="py-3">(직급) {{user.직급}}</p>
                    <p :key="`안전보건간담회_본사_${index}_성명`" class="py-3">(성명) {{user.성명}}</p>
                  </template>
                </div>
              </td>
            </tr>
            <tr>
              <td style="border-bottom: 3px solid #2d2d2d;">현장</td>
              <td class="border-r-0 py-0 text-left" colspan="2" style="border-bottom: 3px solid #2d2d2d;">
                <div class="grid grid-cols-3">
                  <template v-for="(user, index) in form.안전보건간담회_현장">
                    <p :key="`안전보건간담회_현장_${index}_소속`" class="py-3">(소속) {{user.소속}}</p>
                    <p :key="`안전보건간담회_현장_${index}_직급`" class="py-3">(직급) {{user.직급}}</p>
                    <p :key="`안전보건간담회_현장_${index}_성명`" class="py-3">(성명) {{user.성명}}</p>
                  </template>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="border-l-0 py-3">③주요 내용</td>
              <td class="border-r-0 py-3">간담회 사진</td>
            </tr>
            <tr>
              <td colspan="3" class="border-l-0" style="text-align:left; vertical-align:center;">
                <div class="pl-2 whitespace-pre-wrap">{{form.주요내용}}</div>
              </td>
              <td class="border-r-0">
                <div class="flex items-center justify-center" style="max-height: 347px; height:347px;">
                  <img v-if="form.간담회사진 && form.간담회사진.path" class="max-w-full max-h-full" :src="form.간담회사진.path" />
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h3 style="margin-bottom: 6px; font-size:20px;">Ⅲ. 현장 안전·보건활동</h3>
          <table class="w-full" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
            <colgroup>
              <col width="200px"/>
              <col width="200px"/>
              <col width="200px"/>
              <col width="200px"/>
            </colgroup>
            <tbody>
            <tr v-for="n in form.안전보건활동 ? (form.안전보건활동.length +1 )/2 : 1">
              <td class="font-medium border-l-0 py-3">{{ form.안전보건활동[(n-1)*2].content }}</td>
              <td class="py-3">
                <div class="flex justify-center">
                  <span><radio-group flex :items="['이행','미이행']" :value="form.안전보건활동[(n-1)*2].isChecked"/></span>
                </div>
              </td>
              <td class="font-medium border-r-0 py-3">{{form.안전보건활동[(n-1)*2+1] && form.안전보건활동[(n-1)*2+1].content}}</td>
              <td class="py-3">
                <div class="flex justify-center">
                  <span v-if="form.안전보건활동[(n-1)*2+1]" ><radio-group flex :items="['이행','미이행']" :value="form.안전보건활동[(n-1)*2+1].isChecked"/></span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="border-l-0 border-r-0 py-3" style="border-bottom: double">④참고자료</td>
            </tr>
            <tr>
              <td colspan="4" class="border-l-0 border-r-0 text-left" style="height: 300px">
                <div class="whitespace-pre-wrap">{{ form.참고자료 }}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <!-- 2 Page -->
    <div>
      <div style="padding-top:20px;">
      </div>
      <div>
        <h3 style="margin-bottom: 6px; font-size:20px;">Ⅳ. 현장 위험요인 점검</h3>
        <table class="w-full" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
          <colgroup>
            <col width="60px" />
            <col width="100px" />
            <col width="333px" />
            <col width="493px" />
          </colgroup>
          <tbody>
          <tr>
            <td class="border-l-0" rowspan="2" style="border-bottom: 3px solid #2d2d2d;">참석자</td>
            <td >본사</td>
            <td class="border-r-0 py-0 text-left" colspan="2">
              <div class="grid grid-cols-3">
                <template v-for="(user, index) in form.위험요인점검_본사">
                  <p :key="`안전보건간담회_본사_${index}_소속`" class="py-3">(소속) {{user.소속}}</p>
                  <p :key="`안전보건간담회_본사_${index}_직급`" class="py-3">(직급) {{user.직급}}</p>
                  <p :key="`안전보건간담회_본사_${index}_성명`" class="py-3">(성명) {{user.성명}}</p>
                </template>
              </div>
            </td>
          </tr>
          <tr>
            <td style="border-bottom: 3px solid #2d2d2d;">현장</td>
            <td class="border-r-0 py-0 text-left" colspan="2" style="border-bottom: 3px solid #2d2d2d;">
              <div class="grid grid-cols-3">
                <template v-for="(user, index) in form.위험요인점검_현장">
                  <p :key="`안전보건간담회_현장_${index}_소속`" class="py-3">(소속) {{user.소속}}</p>
                  <p :key="`안전보건간담회_현장_${index}_직급`" class="py-3">(직급) {{user.직급}}</p>
                  <p :key="`안전보건간담회_현장_${index}_성명`" class="py-3">(성명) {{user.성명}}</p>
                </template>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <table class="w-full" style="border-bottom: 3px solid #2d2d2d;">
          <colgroup>
            <col width="180px" />
            <col width="403px" />
            <col width="403px" />
          </colgroup>
          <thead>
            <tr>
              <td class="border-l-0 py-3 font-medium" style="border-bottom: double">⑤위험요인</td>
              <td class="py-3 font-medium" style="border-bottom: double">주요 점검 내용</td>
              <td class="border-r-0 py-3 font-medium" style="border-bottom: double">사업주 지원 대책(사업주가 할 수 있는 범위 안에서의 예산·인력·시설 지원 등)</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="n in 12">
              <td class="border-l-0 " style="height:50px;">{{ form.위험요인점검_위험요인[n-1] && form.위험요인점검_위험요인[n-1].위험요인 }}</td>
              <td class="py-3">{{ form.위험요인점검_위험요인[n-1] && form.위험요인점검_위험요인[n-1].주요점검내용 }}</td>
              <td class="border-r-0 py-3">{{ form.위험요인점검_위험요인[n-1] && form.위험요인점검_위험요인[n-1].사업주지원대책 }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mt-3 w-full" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
          <tr>
            <td class="p-3 border-l-0 border-r-0 text-left">
              <div class="p-2" style="border: 1px solid #2D2D2D; font-size: 18px;">
                <h2 class="font-medium mb-1">[참고] 건설현장 핵심 위험요인 16종</h2>
                <p >▴단부·개구부, ▴철골, ▴지붕, ▴비계, ▴사다리, ▴달비계, ▴이동식비계, ▴거푸집동바리, ▴굴착기,  ▴고소작업대, ▴트럭, ▴이동식크레인,
                  ▴타워크레인, ▴항타·항발기, ▴용접장치, ▴밀폐공간</p>
              </div>
            </td>
          </tr>
        </table>

        <div class="mt-2" style="font-size: 18px; color:#2C2C2C; border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d;">
          <p class="py-2">
            <span class="font-medium">작성자 소속 및 성명 : </span>
            <span>{{ form.stdInfo.department }} {{ form.stdInfo.writer_name }}</span>
          </p>
          <p class="py-2">
            <span class="font-medium">작성자 전화번호 : </span>
            <span>{{ form.stdInfo.phone }}</span>
          </p>
          <div class="ml-auto w-1/2">
            <p class="py-2 flex items-center justify-between">
              <span class="inline-block font-medium" style="width: 80px;">작성일</span>
              <span class="flex-1">{{ new Date(form.stdInfo.date).format('yyyy 년 MM 월 DD 일') }}</span>
              <span class="inline-block font-medium" style="width: 120px;"></span>
            </p>
            <p class="py-2 flex items-center justify-between">
              <span class="inline-block font-medium" style="width: 80px;">사업주</span>
              <span class="flex-1">{{ form.보고인.사업주 }}</span>
              <span class="inline-block relative" style="width: 120px;">
                (서명 또는 인)
                <img v-if="form.보고인 && form.보고인.서명"
                     class="absolute top-0 right-0 max-h-16"
                     :src="form.보고인.서명"
                     width="150"
                     style="transform: translateY(-50%);"
                />
              </span>
            </p>
          </div>
          <p class="font-medium py-2" style="border-top: 3px solid #2d2d2d; ">
            <span class="mr-3" style="font-size: 27px;">한국산업안전보건공단 이사장</span>
            귀하
          </p>
        </div>

        <div class="mt-2" style="border-top: 3px solid #2d2d2d; border-bottom: 3px solid #2d2d2d; ">
          <h2 class="py-1 text-center" style="background: #A6A6A6; font-size: 24px;">작성방법</h2>
          <p style="font-size: 20px;">
            ① 연 번: 1쪽 Ⅱ의 각 현장별 연번을 기재합니다.<br>
            ② 사업장관리번호(사업개시번호): 근로복지공단의 산업재해보상보험 가입 시 부여된 도급인 사업장 관리번호(사업개시번호)를 적습니다.<br>
            ③ 주요 내용: 간담회에서 논의된 주요 내용을 작성합니다.<br>
            ④ 참고 자료: 현장 안전·보건활동의 내용을 확인할 수 있는 참고자료를 첨부합니다.<br>
            ⑤ 위험 요인: 현장 순회점검에서 확인한 위험요인을 작성합니다.
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: "Print",
  components: {RadioGroup, PrintCheckbox },

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
    header: Object,
  },

  computed: {

  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
    text-decoration: underline;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3c3c3c;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      //padding: 1.0rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 기본정보 */
  .section-1 .section-2 {
    td div {
      border: none;
    }
  }
}

@media print {
  .section-1 {
    height: 93vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;

      tr:nth-child(4) {
        // 협의 및 의결사항
        height: 55vh;
      }

      tr:nth-child(5) {
        // 기타사항
        height: 20vh;
      }
    }
  }
  .section-2 {
    height: 100vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;
    }
  }
  .section-3 {
    height: 100vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;

      tr:nth-child(4) {
        // 첫 번째 이미지
        height: 40vh;
      }

      tr:nth-child(5) {
        // 첫 번째 내용
        height: 48px;
      }

      tr:nth-child(6) {
        // 두 번째 이미지
        height: 40vh;
      }

      tr:nth-child(7) {
        // 두 번째 내용
        height: 48px;
      }
    }
  }
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    display: table-header-group;
  }
}
</style>
